// @ts-nocheck
import { getConfig } from "../../config/config";
import { CLIENTCID_Depth } from "../../utils/constant";
import { decryptEnv } from "../../helpers";
const { APP_BASE_API_URL, APP_HEAD_KEY, APP_OCP_APIM_KEY, APP_USER_ID, APP_PASSWORD } = getConfig();
export const getCompanyDetail = async (exchange, exchangeType, scripCode, options) => {
    var _a;
    const token = `Bearer ${(_a = localStorage.getItem("JWTToken")) === null || _a === void 0 ? void 0 : _a.replace("JWTToken", "")}`;
    const headers = {
        "Content-Type": "application/json",
        "Authorization": token,
        "Ocp-Apim-Subscription-Key": decryptEnv(APP_OCP_APIM_KEY),
        "AppName": "5PTRADE",
        "ClientId": decryptEnv(CLIENTCID_Depth),
        "UserId": decryptEnv(APP_USER_ID),
        "Password": decryptEnv(APP_PASSWORD),
    };
    const payload = {
        head: {
            appName: "5PTRADE",
            appSource: "23",
            appVer: "1.0",
            key: decryptEnv(APP_HEAD_KEY),
            osName: "Web",
            requestCode: "5PComDtlPgV9"
        },
        body: {
            Exch: exchange,
            ExchType: exchangeType,
            ScripCode: scripCode,
            ClientLoginType: 1,
            Count: 1,
            RefreshRate: "H",
            ClientCode: localStorage.getItem("ClientCode")
        }
    };
    try {
        const fetchOptions = {
            method: "POST",
            credentials: "include",
            headers,
            body: JSON.stringify(payload)
        };
        if (options === null || options === void 0 ? void 0 : options.signal) {
            fetchOptions.signal = options.signal;
        }
        const response = await fetch(`${APP_BASE_API_URL}Tradestation/V9/CompanyDetailPage`, fetchOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
    catch (error) {
        if (error.name !== 'AbortError') {
            console.error("Error fetching company details:", error);
        }
        throw error;
    }
};
